@if (loading) {
<!-- skeleton con la forma del modal: equipo, tarjeta de estado, pestañas y datos -->
<div class="flex animate-pulse flex-col gap-4">
  <div class="grid grid-cols-1 gap-4 lg:grid-cols-12">
    <!-- identidad -->
    <div
      class="flex flex-col items-center gap-3 rounded-xl border border-gray-200 p-4 dark:border-gray-700 lg:col-span-3"
    >
      <div class="h-20 w-40 rounded-lg bg-gray-200 dark:bg-gray-700"></div>
      <div class="h-4 w-32 rounded bg-gray-200 dark:bg-gray-700"></div>
      <div class="h-3 w-20 rounded bg-gray-100 dark:bg-gray-700/60"></div>
      @for (i of [1, 2, 3, 4]; track i) {
      <div class="flex w-full gap-3">
        <div class="h-3 w-12 rounded bg-gray-100 dark:bg-gray-700/60"></div>
        <div class="h-3 flex-1 rounded bg-gray-200 dark:bg-gray-700"></div>
      </div>
      }
    </div>
    <!-- estado y señal -->
    <div
      class="overflow-hidden rounded-xl border border-gray-200 dark:border-gray-700 lg:col-span-5"
    >
      <div class="flex items-center gap-3 border-b border-gray-100 px-4 py-3 dark:border-gray-700">
        <div class="h-7 w-24 rounded-full bg-gray-200 dark:bg-gray-700"></div>
        <div class="flex flex-col gap-1">
          <div class="h-4 w-14 rounded bg-gray-200 dark:bg-gray-700"></div>
          <div class="h-2.5 w-20 rounded bg-gray-100 dark:bg-gray-700/60"></div>
        </div>
        <div class="ml-auto flex gap-2">
          <div class="h-8 w-8 rounded-full bg-gray-200 dark:bg-gray-700"></div>
          <div class="h-8 w-8 rounded-full bg-gray-200 dark:bg-gray-700"></div>
          <div class="h-8 w-16 rounded-full bg-gray-200 dark:bg-gray-700"></div>
        </div>
      </div>
      <div class="grid grid-cols-1 gap-3 px-4 py-3 sm:grid-cols-2">
        @for (i of [1, 2]; track i) {
        <div class="rounded-lg border border-gray-100 p-3 dark:border-gray-700">
          <div class="h-3 w-24 rounded bg-gray-200 dark:bg-gray-700"></div>
          <div class="mt-2 flex items-center gap-2">
            <div class="h-7 w-20 rounded bg-gray-200 dark:bg-gray-700"></div>
            <div class="ml-auto h-4 w-12 rounded-full bg-gray-100 dark:bg-gray-700/60"></div>
          </div>
          <div class="mt-3 h-2 w-full rounded-full bg-gray-200 dark:bg-gray-700"></div>
        </div>
        }
      </div>
      <div class="border-t border-gray-100 px-4 py-2 dark:border-gray-700">
        <div class="h-3 w-28 rounded bg-gray-100 dark:bg-gray-700/60"></div>
      </div>
    </div>
    <!-- indicadores -->
    <div class="grid grid-cols-2 gap-3 lg:col-span-4">
      @for (i of [1, 2, 3, 4, 5, 6]; track i) {
      <div class="flex flex-col gap-2 rounded-xl border border-gray-200 p-3 dark:border-gray-700">
        <div class="h-2.5 w-20 rounded bg-gray-100 dark:bg-gray-700/60"></div>
        <div class="h-5 w-14 rounded bg-gray-200 dark:bg-gray-700"></div>
        <div class="h-2.5 w-16 rounded bg-gray-100 dark:bg-gray-700/60"></div>
      </div>
      }
    </div>
  </div>
  <div class="flex gap-6 border-b border-gray-200 pb-3 dark:border-gray-700">
    @for (i of [1, 2, 3, 4, 5, 6]; track i) {
    <div class="h-4 w-20 rounded bg-gray-200 dark:bg-gray-700"></div>
    }
  </div>
  <div class="grid grid-cols-1 gap-x-10 gap-y-3 lg:grid-cols-2">
    @for (i of [1, 2, 3, 4, 5, 6]; track i) {
    <div class="flex gap-4">
      <div class="h-3.5 w-28 rounded bg-gray-200 dark:bg-gray-700"></div>
      <div class="h-3.5 w-40 rounded bg-gray-100 dark:bg-gray-700/60"></div>
    </div>
    }
  </div>
  <div class="flex gap-2 border-t border-gray-200 pt-3 dark:border-gray-700">
    @for (i of [1, 2, 3, 4]; track i) {
    <div class="h-8 w-28 rounded bg-gray-200 dark:bg-gray-700"></div>
    }
    <div class="ml-auto h-8 w-28 rounded bg-gray-200 dark:bg-gray-700"></div>
    <div class="h-8 w-24 rounded bg-gray-200 dark:bg-gray-700"></div>
  </div>
</div>
} @else if (loadError || !view) {
<p class="rounded bg-red-50 p-4 text-red-700">
  {{ loadError || 'ONU no encontrada en SmartOLT.' }}
</p>
} @else {
<!-- avisos de SmartOLT (p. ej. admin-disabled) -->
@for (alert of view.alerts; track $index) {
<div
  class="mb-3 rounded p-3 text-sm"
  [ngClass]="{
    'bg-yellow-50 text-yellow-800': alert.type === 'warning',
    'bg-red-50 text-red-700': alert.type === 'danger',
    'bg-green-50 text-green-700': alert.type === 'success'
  }"
>
  {{ alert.message }}
</div>
}
<!-- mini dashboard del equipo -->
<div class="mb-4 grid grid-cols-1 gap-4 lg:grid-cols-12">
  <!-- identidad -->
  <div
    class="flex flex-col gap-3 rounded-xl border border-gray-200 bg-white p-4 shadow-sm dark:border-gray-700 dark:bg-gray-800 lg:col-span-3"
  >
    @if (view.imageUrl) {
    <img class="mx-auto max-h-20 object-contain" [src]="view.imageUrl" alt="Equipo" />
    }
    <div class="text-center">
      <p class="font-mono text-base font-bold tracking-wide text-gray-800 dark:text-gray-100">
        {{ view.sn }}
      </p>
      <p class="text-xs text-gray-500">{{ view.onuType.name }}</p>
    </div>
    <dl class="grid grid-cols-[max-content_1fr] gap-x-3 gap-y-1 text-xs">
      <dt class="text-gray-400">Cliente</dt>
      <dd
        class="truncate font-medium text-gray-700 dark:text-gray-200"
        [title]="view.location.name"
      >
        {{ view.location.name || '–' }}
      </dd>
      <dt class="text-gray-400">OLT</dt>
      <dd class="truncate text-gray-700 dark:text-gray-200" [title]="view.olt.name">
        {{ view.olt.name }}
      </dd>
      <dt class="text-gray-400">PON</dt>
      <dd class="truncate text-gray-700 dark:text-gray-200" [title]="view.port.label">
        {{ view.onu.name }}
      </dd>
      @if (view.location.odbId && view.location.odbId !== '0') {
      <dt class="text-gray-400">Splitter</dt>
      <dd class="truncate">
        <button
          type="button"
          class="max-w-full truncate text-blue-600 hover:underline"
          title="Ver el splitter con sus puertos y ONUs"
          (click)="openSplitter()"
        >
          {{ view.location.odbName }}
        </button>
      </dd>
      }
      <dt class="text-gray-400">Zona</dt>
      <dd class="truncate text-gray-700 dark:text-gray-200">{{ view.location.zoneName || '–' }}</dd>
    </dl>
    <button
      type="button"
      class="mt-auto flex items-center justify-center gap-1.5 rounded-lg border border-gray-200 px-2 py-1.5 text-xs font-medium text-gray-600 transition hover:border-blue-300 hover:bg-blue-50 hover:text-blue-700 dark:border-gray-600 dark:text-gray-300"
      title="Copiar a SmartOLT el nombre, dirección, contacto y coordenadas del cliente y contrato"
      (click)="syncOpen = true"
    >
      <i class="pi pi-sync text-[11px]"></i> Sincronizar con el sistema
    </button>
  </div>

  <!-- estado y señal, como la tarjeta de SmartOLT -->
  <div class="lg:col-span-5">
    @if (view.statusSignal; as signal) {
    <app-onu-status-panel
      [signal]="signal"
      [onuId]="view.onuId"
      (signalChange)="view.statusSignal = $event"
      (trafficLive)="live()"
    />
    }
  </div>

  <!-- indicadores -->
  <div class="grid grid-cols-2 gap-3 lg:col-span-4">
    <button
      type="button"
      class="flex flex-col rounded-xl border p-3 text-left shadow-sm transition hover:shadow"
      [ngClass]="
        disconnections && disconnections.day > 0
          ? 'border-red-200 bg-red-50 dark:border-red-900 dark:bg-red-950/30'
          : 'border-gray-200 bg-white dark:border-gray-700 dark:bg-gray-800'
      "
      title="Online a LOS, Power fail, Offline o login. Ver historial de estado"
      (click)="openGraphsTab()"
    >
      <span class="text-[11px] uppercase tracking-wide text-gray-500">Desconexiones</span>
      @if (disconnections) {
      <span class="mt-1 text-xl font-bold" [class.text-red-600]="disconnections.day > 0">
        {{ disconnections.day }} <small class="text-xs font-normal text-gray-500">24 h</small>
      </span>
      <span class="text-xs text-gray-500">{{ disconnections.week }} en 7 días</span>
      } @else {
      <span class="mt-1 text-xl font-bold text-green-600">0</span>
      <span class="text-xs text-gray-500">sin caídas recientes</span>
      }
    </button>

    <button
      type="button"
      class="flex flex-col rounded-xl border border-gray-200 bg-white p-3 text-left shadow-sm transition hover:shadow dark:border-gray-700 dark:bg-gray-800"
      title="Ver gráficos de tráfico"
      (click)="openGraphsTab()"
    >
      <span class="text-[11px] uppercase tracking-wide text-gray-500">Tráfico actual</span>
      @if (kpis.loaded) {
      <span class="mt-1 text-sm font-bold text-blue-600">
        <i class="pi pi-arrow-down text-[10px]"></i> {{ formatMbps(kpis.trafficDown) }}
      </span>
      <span class="text-sm font-bold text-orange-500">
        <i class="pi pi-arrow-up text-[10px]"></i> {{ formatMbps(kpis.trafficUp) }}
      </span>
      } @else {
      <span class="mt-2 h-4 w-20 animate-pulse rounded bg-gray-200"></span>
      <span class="mt-1 h-4 w-16 animate-pulse rounded bg-gray-200"></span>
      }
    </button>

    <div
      class="flex flex-col rounded-xl border border-gray-200 bg-white p-3 shadow-sm dark:border-gray-700 dark:bg-gray-800"
    >
      <span class="text-[11px] uppercase tracking-wide text-gray-500">Consumo hoy</span>
      @let usage = kpis.usageToday; @if (!kpis.loaded) {
      <span class="mt-2 h-5 w-16 animate-pulse rounded bg-gray-200"></span>
      } @else if (usage) {
      <span class="mt-1 text-xl font-bold text-gray-800 dark:text-gray-100">{{ usage.total }}</span>
      <span class="text-xs text-gray-500">↓ {{ usage.download }} · ↑ {{ usage.upload }}</span>
      } @else {
      <span class="mt-1 text-xl font-bold text-gray-400">–</span>
      }
    </div>

    <button
      type="button"
      class="flex flex-col rounded-xl border border-gray-200 bg-white p-3 text-left shadow-sm transition hover:shadow dark:border-gray-700 dark:bg-gray-800"
      title="Cambiar perfiles de velocidad"
      (click)="edit('speed')"
    >
      <span class="text-[11px] uppercase tracking-wide text-gray-500">Plan</span>
      <span
        class="mt-1 truncate text-sm font-bold text-gray-800 dark:text-gray-100"
        [title]="view.speedProfiles?.download ?? ''"
      >
        {{ view.speedProfiles?.download || '–' }}
      </span>
      @if (view.speedProfiles && view.speedProfiles.upload !== view.speedProfiles.download) {
      <span class="truncate text-xs text-gray-500">↑ {{ view.speedProfiles.upload }}</span>
      }
    </button>

    <button
      type="button"
      class="flex flex-col rounded-xl border border-gray-200 bg-white p-3 text-left shadow-sm transition hover:shadow dark:border-gray-700 dark:bg-gray-800"
      title="Ver puertos y WiFi"
      (click)="activeTab = 1; onTabChange(1)"
    >
      <span class="text-[11px] uppercase tracking-wide text-gray-500">Puertos LAN</span>
      @if (linkedPorts.read) {
      <span
        class="mt-1 text-xl font-bold"
        [class.text-green-600]="linkedPorts.up > 0"
        [class.text-gray-400]="!linkedPorts.up"
      >
        {{ linkedPorts.up }}<small class="text-xs font-normal text-gray-500"
          >/{{ linkedPorts.total }}</small
        >
      </span>
      <span class="text-xs text-gray-500">con enlace</span>
      } @else if (linkedPorts.total) {
      <span class="mt-2 h-5 w-12 animate-pulse rounded bg-gray-200"></span>
      } @else {
      <span class="mt-1 text-xl font-bold text-gray-400">–</span>
      }
    </button>

    <button
      type="button"
      class="flex flex-col rounded-xl border border-gray-200 bg-white p-3 text-left shadow-sm transition hover:shadow dark:border-gray-700 dark:bg-gray-800"
      title="Cambiar modo de la ONU y WAN"
      (click)="edit('mode')"
    >
      <span class="text-[11px] uppercase tracking-wide text-gray-500">WAN</span>
      <span class="mt-1 text-sm font-bold text-gray-800 dark:text-gray-100">
        {{ view.mode['mode'] || '–' }}@if (view.wanSetupMode) { · {{ view.wanSetupMode }} }
      </span>
      <span class="text-xs text-gray-500"
        >VLAN {{ view.mainVlanId || view.attachedVlans || '–' }}</span
      >
    </button>
  </div>
</div>

<p-tabView [(activeIndex)]="activeTab" (activeIndexChange)="onTabChange($event)">
  <!-- Información -->
  <p-tabPanel header="Información">
    <div class="grid grid-cols-1 gap-6 text-sm lg:grid-cols-2">
      <dl class="grid grid-cols-[max-content_1fr] gap-x-4 gap-y-2">
        <dt class="font-semibold text-gray-600">OLT</dt>
        <dd>
          <button class="text-left text-blue-600 hover:underline" (click)="edit('move')">
            {{ view.olt.name }}
          </button>
        </dd>
        <dt class="font-semibold text-gray-600">Tarjeta / Puerto</dt>
        <dd>
          <button class="text-left text-blue-600 hover:underline" (click)="edit('move')">
            {{ view.board }} / {{ view.port.label }}
          </button>
        </dd>
        <dt class="font-semibold text-gray-600">ONU</dt>
        <dd>
          <button class="text-blue-600 hover:underline" (click)="edit('allocated')">
            {{ view.onu.name }}
          </button>
        </dd>
        <dt class="font-semibold text-gray-600">Canal GPON</dt>
        <dd>
          <button class="text-blue-600 hover:underline" (click)="edit('gpon_type')">
            {{ view.gponType.label }}
          </button>
        </dd>
        <dt class="font-semibold text-gray-600">SN</dt>
        <dd>
          <button class="text-blue-600 hover:underline" (click)="edit('sn')">{{ view.sn }}</button>
        </dd>
        <dt class="font-semibold text-gray-600">Tipo de ONU</dt>
        <dd>
          <button class="text-blue-600 hover:underline" (click)="edit('onu_type')">
            {{ view.onuType.name }}
          </button>
        </dd>
        <dt class="font-semibold text-gray-600">Zona</dt>
        <dd>
          <button class="text-left text-blue-600 hover:underline" (click)="edit('location')">
            {{ view.location.zoneName || 'Ninguna' }}
          </button>
        </dd>
        <dt class="font-semibold text-gray-600">Splitter</dt>
        <dd class="flex items-center gap-2">
          <button class="text-left text-blue-600 hover:underline" (click)="edit('location')">
            {{ view.location.odbName || 'Ninguno' }}
          </button>
          @if (view.location.odbId && view.location.odbId !== '0') {
          <button
            type="button"
            class="text-gray-500 hover:text-blue-700"
            title="Ver el splitter con sus puertos y ONUs"
            (click)="openSplitter()"
          >
            <i class="pi pi-sitemap"></i>
          </button>
          }
        </dd>
        <dt class="font-semibold text-gray-600">Sector</dt>
        <dd>
          <button class="text-blue-600 hover:underline" (click)="edit('location')">
            {{ view.location.sectorName || 'Ninguno' }}
          </button>
        </dd>
        <dt class="font-semibold text-gray-600">Nombre</dt>
        <dd>
          <button class="text-left text-blue-600 hover:underline" (click)="edit('location')">
            {{ view.location.name || 'Ninguno' }}
          </button>
        </dd>
        <dt class="font-semibold text-gray-600">Dirección / comentario</dt>
        <dd>
          <button class="text-left text-blue-600 hover:underline" (click)="edit('location')">
            {{ view.location.description || 'Ninguno' }}
          </button>
        </dd>
        <dt class="font-semibold text-gray-600">Contacto</dt>
        <dd>
          <button class="text-blue-600 hover:underline" (click)="edit('location')">
            {{ view.location.contact || 'Ninguno' }}
          </button>
        </dd>
        <dt class="font-semibold text-gray-600">Fecha de autorización</dt>
        <dd>{{ view.authorizationDate }}</dd>
        <dt class="font-semibold text-gray-600">ID externo</dt>
        <dd>
          <button class="text-blue-600 hover:underline" (click)="edit('external_id')">
            {{ view.externalId }}
          </button>
        </dd>
      </dl>

      <dl class="grid grid-cols-[max-content_1fr] content-start gap-x-4 gap-y-2">
        <dt class="font-semibold text-gray-600">Perfil TR069</dt>
        <dd>
          <button class="text-blue-600 hover:underline" (click)="edit('mgmt')">
            {{ view.tr069Profile }}
          </button>
        </dd>
        <dt class="font-semibold text-gray-600">Mgmt IP</dt>
        <dd>
          <button class="text-blue-600 hover:underline" (click)="edit('mgmt')">
            {{ view.fields['Mgmt IP'] || view.mgmtIp['mgmtIpMode'] }}
          </button>
        </dd>
        <dt class="font-semibold text-gray-600">VLANs adjuntas</dt>
        <dd>
          <button class="text-blue-600 hover:underline" (click)="edit('vlans')">
            {{ view.attachedVlans }}
          </button>
        </dd>
        <dt class="font-semibold text-gray-600">Modo ONU</dt>
        <dd>
          <button class="text-left text-blue-600 hover:underline" (click)="edit('mode')">
            {{ view.modeLabel }}
          </button>
        </dd>
        @if (view.wanSetupMode) {
        <dt class="font-semibold text-gray-600">Modo WAN</dt>
        <dd>
          <button class="text-blue-600 hover:underline" (click)="edit('mode')">
            {{ view.wanSetupMode }}
          </button>
        </dd>
        }
      </dl>
    </div>
  </p-tabPanel>

  <!-- Servicio -->
  <p-tabPanel header="Servicio">
    <div class="flex flex-col gap-6 text-sm">
      <section>
        <h4 class="mb-2 font-semibold text-gray-700">Perfiles de velocidad</h4>
        <table class="min-w-full" aria-describedby="Perfiles de velocidad">
          <thead class="border-b-2 border-blue-400 text-left">
            <tr>
              <th class="px-3 py-2">Descarga</th>
              <th class="px-3 py-2">Subida</th>
              <th class="px-3 py-2"></th>
            </tr>
          </thead>
          <tbody>
            <tr class="border-b">
              <td class="px-3 py-2">{{ view.speedProfiles?.download || '–' }}</td>
              <td class="px-3 py-2">{{ view.speedProfiles?.upload || '–' }}</td>
              <td class="px-3 py-2 text-right">
                <p-button
                  label="Configurar"
                  icon="pi pi-cog"
                  [text]="true"
                  size="small"
                  (onClick)="edit('speed')"
                />
              </td>
            </tr>
          </tbody>
        </table>
      </section>

      <section>
        <h4 class="mb-2 font-semibold text-gray-700">Puertos Ethernet</h4>
        <table class="min-w-full" aria-describedby="Puertos Ethernet">
          <thead class="border-b-2 border-blue-400 text-left">
            <tr>
              <th class="px-3 py-2">Puerto</th>
              <th class="px-3 py-2">Estado</th>
              <th class="px-3 py-2">Modo</th>
              <th class="px-3 py-2">DHCP</th>
              <th class="px-3 py-2">
                Enlace
                <button
                  type="button"
                  class="ml-1 text-blue-600"
                  title="Actualizar enlace"
                  (click)="refreshPortLinks()"
                >
                  <i class="pi pi-refresh text-xs"></i>
                </button>
              </th>
              <th class="px-3 py-2"></th>
            </tr>
          </thead>
          <tbody>
            @for (port of view.ethernetPorts; track port.id) {
            <tr class="border-b">
              <td class="px-3 py-2">{{ port.port }}</td>
              <td class="px-3 py-2">
                <span
                  [class.text-green-700]="port.adminState === 'Enabled'"
                  [class.text-red-600]="port.adminState !== 'Enabled'"
                >
                  {{ port.adminState }}
                </span>
              </td>
              <td class="px-3 py-2">{{ port.mode }}</td>
              <td class="px-3 py-2">{{ port.dhcp }}</td>
              <td class="px-3 py-2">
                @let link = portLinks[port.id]; @if (link === undefined) {
                <i class="pi pi-spin pi-spinner text-xs text-gray-400"></i>
                } @else if (link) {
                <span
                  [class.text-green-700]="link.link === 'up'"
                  [class.text-gray-500]="link.link !== 'up'"
                >
                  {{ portLinkLabel(link) }}
                </span>
                } @else {
                <span class="text-gray-400">–</span>
                }
              </td>
              <td class="px-3 py-2 text-right">
                <p-button
                  label="Configurar"
                  icon="pi pi-cog"
                  [text]="true"
                  size="small"
                  (onClick)="edit('port', port)"
                />
              </td>
            </tr>
            } @empty {
            <tr>
              <td colspan="6" class="px-3 py-2 text-gray-500">
                Este tipo de ONU no tiene puertos Ethernet.
              </td>
            </tr>
            }
          </tbody>
        </table>
      </section>

      @if (view.hasWifi && (wifiLoading || !wifi || wifi.supported)) {
      <section>
        <div class="mb-2 flex flex-wrap items-center justify-between gap-2">
          <h4 class="font-semibold text-gray-700">WiFi</h4>
          @if (wifi) {
          <label class="flex items-center gap-2 text-sm">
            <input
              type="checkbox"
              [checked]="wifi.enabled"
              [disabled]="!!actionLoading['wifi_status']"
              (change)="toggleWifi($any($event.target).checked)"
            />
            Habilitado @if (actionLoading['wifi_status']) {
            <i class="pi pi-spin pi-spinner text-xs"></i>
            }
          </label>
          }
        </div>
        @if (wifiLoading && !wifi) {
        <div class="h-16 animate-pulse rounded bg-gray-100"></div>
        } @else if (wifi && wifi.enabled) {
        <table class="min-w-full" aria-describedby="WiFi">
          <thead class="border-b-2 border-blue-400 text-left">
            <tr>
              <th class="px-3 py-2">Puerto</th>
              <th class="px-3 py-2">Estado</th>
              <th class="px-3 py-2">Modo</th>
              <th class="px-3 py-2">SSID</th>
              <th class="px-3 py-2">DHCP</th>
              <th class="px-3 py-2"></th>
            </tr>
          </thead>
          <tbody>
            @for (wport of wifi.ports; track wport.id; let first = $first) { @if (first ||
            wport.band !== wifi.ports[$index - 1].band) {
            <tr>
              <td colspan="6" class="bg-gray-50 px-3 py-1 text-xs font-semibold text-gray-600">
                <i class="pi pi-wifi"></i> {{ wport.band }}
              </td>
            </tr>
            }
            <tr class="border-b">
              <td class="px-3 py-2">{{ wport.port }}</td>
              <td class="px-3 py-2">{{ wport.adminState }}</td>
              <td class="px-3 py-2">{{ wport.mode }}</td>
              <td class="px-3 py-2">{{ wport.ssid || '–' }}</td>
              <td class="px-3 py-2">{{ wport.dhcp }}</td>
              <td class="px-3 py-2 text-right">
                <p-button
                  label="Configurar"
                  icon="pi pi-cog"
                  [text]="true"
                  size="small"
                  (onClick)="edit('wifi', null, wport)"
                />
              </td>
            </tr>
            } @for (free of wifi.available; track free.id) {
            <tr>
              <td colspan="6" class="px-3 py-1">
                <p-button
                  [label]="'Agregar SSID' + (free.band ? ' (' + free.band + ')' : '')"
                  icon="pi pi-plus"
                  [text]="true"
                  size="small"
                  (onClick)="edit('wifi', null, free)"
                />
              </td>
            </tr>
            }
          </tbody>
        </table>
        } @else if (wifi) {
        <p class="text-sm text-gray-500">El WiFi de esta ONU está deshabilitado.</p>
        } @else {
        <p class="text-sm text-gray-500">No se pudo leer la configuración WiFi.</p>
        }
      </section>
      }

      <section class="grid grid-cols-[max-content_1fr] gap-x-4 gap-y-2">
        @if (view.voip.label) {
        <span class="font-semibold text-gray-600">Servicio VoIP</span>
        <span>
          <button class="text-blue-600 hover:underline" (click)="edit('mgmt')">
            {{ view.voip.label }}
          </button>
        </span>
        } @if (view.catv) {
        <span class="font-semibold text-gray-600">CATV</span>
        <span>{{ view.catv }}</span>
        }
      </section>
    </div>
  </p-tabPanel>

  <!-- Diagnóstico -->
  <p-tabPanel header="Diagnóstico">
    <div class="flex flex-wrap gap-2">
      <p-button
        label="Get status"
        severity="info"
        [loading]="diagLoading && diagKind === 'status'"
        (onClick)="diag('status')"
      />
      <p-button
        label="Show running-config"
        severity="help"
        [loading]="diagLoading && diagKind === 'running_config'"
        (onClick)="diag('running_config')"
      />
      <p-button
        label="SW info"
        severity="info"
        [loading]="diagLoading && diagKind === 'sw_info'"
        (onClick)="diag('sw_info')"
      />
      <!-- gris si la ONU no tiene perfil TR-069, como en SmartOLT -->
      <p-button
        label="TR-069"
        icon="pi pi-server"
        [severity]="tr069Enabled ? 'info' : 'secondary'"
        [outlined]="!tr069Open"
        (onClick)="openTr069()"
      />
      <p-button label="Tráfico en vivo" severity="success" icon="pi pi-bolt" (onClick)="live()" />
    </div>
    @if (tr069Open) {
    <div class="mt-4">
      <app-onu-tr069 [onuId]="view.onuId" [enabled]="tr069Enabled" />
    </div>
    } @else {
    <!-- consola de la OLT: mismo espacio vacío, cargando o con resultado -->
    <div class="mt-4 overflow-hidden rounded-xl border border-gray-800 bg-gray-900 shadow-sm">
      <div class="flex items-center gap-2 border-b border-gray-800 bg-gray-950/60 px-4 py-2">
        <span class="flex gap-1.5">
          <span class="h-2.5 w-2.5 rounded-full bg-red-500/80"></span>
          <span class="h-2.5 w-2.5 rounded-full bg-yellow-500/80"></span>
          <span class="h-2.5 w-2.5 rounded-full bg-green-500/80"></span>
        </span>
        <span class="ml-2 text-xs font-medium text-gray-300">
          {{ diagKind ? diagTitles[diagKind] : 'Consola de la OLT' }}
        </span>
        @if (diagLoading) {
        <span class="ml-auto flex items-center gap-1.5 text-xs text-gray-400">
          <i class="pi pi-spin pi-spinner text-[10px]"></i> Consultando la OLT…
        </span>
        } @else if (diagKind) {
        <span class="ml-auto text-xs text-gray-500">{{ view.onu.name }}</span>
        }
      </div>
      <div class="h-[45vh] min-h-[260px] overflow-auto">
        @if (diagLoading) {
        <div class="flex animate-pulse flex-col gap-2.5 p-4">
          @for (w of [40, 72, 56, 64, 30, 80, 48, 60, 36, 70]; track $index) {
          <div class="h-2.5 rounded bg-gray-700/70" [style.width.%]="w"></div>
          }
        </div>
        } @else if (diagKind) {
        <pre class="font-mono whitespace-pre-wrap p-4 text-xs leading-relaxed text-green-200">
{{ diagOutput }}</pre
        >
        } @else {
        <div class="flex h-full flex-col items-center justify-center gap-3 px-6 text-center">
          <span
            class="flex h-12 w-12 items-center justify-center rounded-full bg-gray-800 text-gray-400"
          >
            <i class="pi pi-desktop text-xl"></i>
          </span>
          <div>
            <p class="text-sm font-semibold text-gray-200">Sin consultas todavía</p>
            <p class="mt-1 max-w-md text-xs text-gray-400">
              Use <strong class="text-gray-300">Get status</strong> para ver la óptica, CATV y
              detalles de la ONU, <strong class="text-gray-300">Show running-config</strong> para la
              configuración aplicada en la OLT o <strong class="text-gray-300">SW info</strong> para
              el firmware y los puertos que reporta el equipo.
            </p>
          </div>
        </div>
        }
      </div>
    </div>
    }
  </p-tabPanel>

  <!-- Gráficos -->
  <p-tabPanel header="Gráficos">
    <ng-template pTemplate="content">
      <app-onu-graphs [onuId]="view.onuId" />
    </ng-template>
  </p-tabPanel>

  <!-- Historial -->
  <p-tabPanel header="Historial">
    @if (history === null) {
    <div class="h-32 animate-pulse rounded bg-gray-100"></div>
    } @else {
    <div class="max-h-[50vh] overflow-auto">
      <table class="min-w-full text-sm" aria-describedby="Historial de la ONU">
        <thead class="sticky top-0 border-b-2 border-blue-400 bg-white text-left">
          <tr>
            <th class="px-3 py-2">Acción</th>
            <th class="px-3 py-2">Usuario</th>
            <th class="px-3 py-2">IP</th>
            <th class="px-3 py-2">Fecha</th>
          </tr>
        </thead>
        <tbody>
          @for (item of history; track $index) {
          <tr class="border-b odd:bg-gray-50">
            <td class="px-3 py-2">{{ item.action }}</td>
            <td class="px-3 py-2">{{ item.user }}</td>
            <td class="whitespace-nowrap px-3 py-2">{{ item.ip }}</td>
            <td class="whitespace-nowrap px-3 py-2">{{ item.date }}</td>
          </tr>
          } @empty {
          <tr>
            <td colspan="4" class="px-3 py-4 text-center text-gray-500">Sin historial.</td>
          </tr>
          }
        </tbody>
      </table>
    </div>
    }
  </p-tabPanel>

  <!-- Notas -->
  <p-tabPanel header="Notas">
    <ng-template pTemplate="content">
      <app-onu-notes [onuId]="view.onuId" [assignees]="view.options['note_assignees'] ?? []" />
    </ng-template>
  </p-tabPanel>
</p-tabView>

<!-- acciones sobre el equipo: una sola línea, fija al pie del modal -->
<div
  class="sticky bottom-0 z-10 -mx-6 mt-4 flex items-center gap-2 overflow-x-auto border-t border-gray-200 bg-white px-6 py-3 shadow-[0_-4px_12px_-6px_rgba(0,0,0,0.12)] dark:border-gray-700 dark:bg-gray-800"
>
  <p-button
    label="Reiniciar"
    icon="pi pi-refresh"
    severity="warning"
    size="small"
    styleClass="whitespace-nowrap"
    [loading]="!!actionLoading['reboot']"
    (onClick)="deviceAction('reboot')"
  />
  <p-button
    label="Resincronizar"
    icon="pi pi-sync"
    severity="warning"
    size="small"
    styleClass="whitespace-nowrap"
    [outlined]="true"
    [loading]="!!actionLoading['resync']"
    (onClick)="deviceAction('resync')"
  />
  <p-button
    label="Restaurar fábrica"
    icon="pi pi-history"
    severity="warning"
    size="small"
    styleClass="whitespace-nowrap"
    [outlined]="true"
    [loading]="!!actionLoading['restore_defaults']"
    (onClick)="deviceAction('restore_defaults')"
  />
  <p-button
    label="Firmware"
    icon="pi pi-download"
    severity="secondary"
    size="small"
    styleClass="whitespace-nowrap"
    [outlined]="true"
    [loading]="!!actionLoading['firmware_upgrade']"
    (onClick)="deviceAction('firmware_upgrade')"
  />
  <span class="ml-auto"></span>
  @if (view.adminDisabled) {
  <p-button
    label="Habilitar"
    icon="pi pi-check-circle"
    severity="success"
    size="small"
    styleClass="whitespace-nowrap"
    [loading]="!!actionLoading['enable']"
    (onClick)="deviceAction('enable')"
  />
  } @else {
  <p-button
    label="Deshabilitar"
    icon="pi pi-ban"
    severity="secondary"
    size="small"
    styleClass="whitespace-nowrap"
    [outlined]="true"
    [loading]="!!actionLoading['disable']"
    (onClick)="deviceAction('disable')"
  />
  } @if (canDelete) {
  <p-button
    label="Eliminar"
    icon="pi pi-trash"
    severity="danger"
    size="small"
    styleClass="whitespace-nowrap"
    [outlined]="true"
    [loading]="deleteLoading"
    (onClick)="deleteOnu()"
  />
  }
</div>

<app-onu-splitter-dialog
  [splitter]="splitterOpen ? view : null"
  [name]="splitterName"
  (openOnu)="openSplitterOnu($event)"
  (changed)="onSplitterChanged()"
  (closed)="splitterOpen = false"
/>

<p-dialog
  header="Sincronizar con el sistema"
  [visible]="syncOpen"
  (visibleChange)="!$event && (syncOpen = false)"
  [modal]="true"
  [draggable]="false"
  appendTo="body"
  [style]="{ width: '620px', maxWidth: '95vw' }"
>
  @if (syncOpen) {
  <app-onu-sync-form
    [onuId]="view.onuId"
    (synced)="onSynced($event)"
    (cancelled)="syncOpen = false"
  />
  }
</p-dialog>

<p-dialog
  [header]="editForm ? editTitles[editForm] : ''"
  [visible]="!!editForm"
  (visibleChange)="!$event && (editForm = null)"
  [modal]="true"
  [draggable]="false"
  appendTo="body"
  [style]="{ width: '640px', maxWidth: '95vw' }"
>
  @if (editForm) {
  <app-onu-edit-form
    [view]="view"
    [form]="editForm"
    [port]="editPort"
    [wifiPort]="editWifiPort"
    (saved)="onSaved($event)"
    (cancelled)="editForm = null"
  />
  }
</p-dialog>
}
